import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import Chip from '@mui/material/Chip'
import { useAppServices } from 'hook/services'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDButton from 'components/MDButton'

function BasicInfoApp({ data, handleChange }) {
  const Service = useAppServices()
  const { id } = useParams()
  const [image, setImage] = useState(null)
  const [previewUrlLogo, setpreviewUrlLogo] = useState(data?.app_profile_logo)
  const [formData, setFormData] = useState({
    app_name: data?.app_name || '',
    tagline: data?.tagline || '',
    company: data?.company || '',
    website: data?.website || '',
    category: data?.category || [],
    business_niche: data?.business_niche || []
  })

  const [errors, setErrors] = useState({
    previewLogo: '',
    app_name: '',
    category: '',
    company: '',
    tagline: '',
    business_niche: ''
  })

  const categories = [
    'Marketing',
    'Advertising',
    'E-commernce',
    'Finance',
    'Health & Fitness',
  ]
  const businessNiches = [
    'Dental',
    'SaaS',
    'E-commerce',
    'Marketplace',

  ]

  const handleImageUpload = (e) => {
    const file = e.target.files[0]
    if (file) {
      setImage(file)
      setpreviewUrlLogo(URL.createObjectURL(file))
      setErrors(prev => ({ ...prev, previewLogo: '' }))
    }
  }


  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }))
    }
  }

  const handleMultiSelectChange = (event) => {
    const { name, value } = event.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }))
    }
  }

  const validateForm = () => {
    const newErrors = {
      app_name: '',
      category: '',
      previewLogo: '',
      company: '',
      tagline: '',
      business_niche: ''
    }
    let isValid = true

    if (!formData.app_name.trim()) {
      newErrors.app_name = 'App name is required'
      isValid = false
    }

    if (formData.category.length === 0) {
      newErrors.category = 'At least one category is required'
      isValid = false
    }

    if (!formData.company.trim()) {
      newErrors.company = 'Company is required'
      isValid = false
    }

    if (!formData.tagline.trim()) {
      newErrors.tagline = 'Tagline is required'
      isValid = false
    }

    if (formData.business_niche.length === 0) {
      newErrors.business_niche = 'At least one business niche is required'
      isValid = false
    }

    if (!previewUrlLogo && !data?.app_profile) {
      newErrors.previewLogo = 'App logo is required'
      isValid = false
    }

    setErrors(prev => ({ ...prev, ...newErrors }))
    return isValid
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!validateForm()) return

    let imageUrl = data?.app_profile_logo
    if (image) {
      const form = new FormData()
      form.append('image', image, image.name)
      const desiredPath = `design/${id}/preview`
      const { response } = await Service.utils.upload_image({
        toaster: false,
        payload: form,
        query: `desiredPath=${desiredPath}`,
      })

      if (response?.data) {
        imageUrl = response.data
      } else {
        setErrors(prev => ({ ...prev, previewLogo: 'Image upload failed' }))
        return
      }
    }
    const payload = {
      _id: id,
      app_name: formData.app_name,
      tagline: formData.tagline,
      company: formData.company,
      website: formData.website,
      category: formData.category,
      business_niche: formData.business_niche,
      app_profile_logo: imageUrl,
    }
    console.log("payload", payload)

    const { response } = await Service.snapshot_onboarding.update({ payload })
    if (response) handleChange()
  }

  return (
    <Card id="basic-info" key={data?._id}>
      <MDBox p={3}>
        <MDTypography variant="h5">Basic Info</MDTypography>
      </MDBox>
      <MDBox component="form" onSubmit={handleSubmit} pb={3} px={3}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              required
              label="App Name *"
              name="app_name"
              value={formData.app_name}
              onChange={handleInputChange}
              error={!!errors.app_name}
              helperText={errors.app_name}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              required
              label="Company "
              name="company"
              value={formData.company}
              onChange={handleInputChange}
              error={!!errors.company}
              helperText={errors.company}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle2" gutterBottom>
              App Logo <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Box
              sx={{
                border: '1px dashed #ccc',
                padding: 2,
                textAlign: 'center',
                borderRadius: 2,
                background: '#fafafa',
              }}
            >
              <input
                type="file"
                accept="image/png, image/jpeg, image/jpg, image/gif, image/svg"
                onChange={handleImageUpload}
                style={{ display: 'none' }}
                id="upload-image-basic"
              />
              <label htmlFor="upload-image-basic" style={{ cursor: 'pointer' }}>
                <Typography color="primary">Click to upload</Typography>
                <Typography variant="body2">
                  PNG, JPG, SVG, GIF (Min: 640×360px, Max: 960×540px)
                </Typography>
              </label>
              {previewUrlLogo && (
                <Box mt={2}>
                  <img
                    src={previewUrlLogo}
                    alt="Preview"
                    style={{ maxWidth: '100%', maxHeight: '300px', borderRadius: '8px' }}
                  />
                </Box>
              )}
            </Box>
            {errors.previewLogo && (
              <Typography color="error" variant="caption">
                {errors.previewLogo}
              </Typography>
            )}
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              required
              label="Tagline "
              name="tagline"
              value={formData.tagline}
              onChange={handleInputChange}
              error={!!errors.tagline}
              helperText={errors.tagline || "Short description of your app"}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Website"
              name="website"
              value={formData.website}
              onChange={handleInputChange}
              helperText="https://example.com"
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl fullWidth error={!!errors.category}>
              <InputLabel id="category-label">Categories *</InputLabel>
              <Select
                labelId="category-label"
                multiple
                value={formData.category}
                onChange={handleMultiSelectChange}
                name="category"
                label="Categories *"
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
              >
                {categories.map((category) => (
                  <MenuItem key={category} value={category}>
                    {category}
                  </MenuItem>
                ))}
              </Select>
              {errors.category && (
                <Typography color="error" variant="caption">
                  {errors.category}
                </Typography>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl fullWidth error={!!errors.business_niche}>
              <InputLabel id="business-niche-label">Business Niches *</InputLabel>
              <Select
                labelId="business-niche-label"
                multiple
                value={formData.business_niche}
                onChange={handleMultiSelectChange}
                name="business_niche"
                label="Business Niches *"
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
              >
                {businessNiches.map((niche) => (
                  <MenuItem key={niche} value={niche}>
                    {niche}
                  </MenuItem>
                ))}
              </Select>
              {errors.business_niche && (
                <Typography color="error" variant="caption">
                  {errors.business_niche}
                </Typography>
              )}
            </FormControl>
          </Grid>


        </Grid>

        <MDBox display="flex" justifyContent="flex-end" mt={3}>
          <MDButton variant="gradient" color="dark" type="submit">
            Update
          </MDButton>
        </MDBox>
      </MDBox>
    </Card>
  )
}

export default BasicInfoApp